import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-modal-overlay',
  templateUrl: './modal-overlay.component.html',
  styleUrls: ['./modal-overlay.component.scss'],
  standalone: true
})
export class ModalOverlayComponent {
  @Output() backdropClick = new EventEmitter<void>();
}
